// Module
var code = "<section class=\"content-area-wrapper even-section\"> <div class=\"content-area content-area--divider contact-media-box\"> <h3 class=\"primary-heading\">Notes</h3> <div class=\"contact-media-box--content\"> <div class=\"ql-notes ql-editor\" ng-bind-html=\"vm.contact.notes\"></div> </div> </div> </section> <section></section> ";
// Exports
module.exports = code;